import { createAction, props } from '@ngrx/store'
import { NotificationModel } from '@models/notification.model'
import { RequestModel } from '@models/request.model'

/**
 * Action that is launched to set an inactivity time in app state
 * Receives a number
 */
export const setInactivityTime = createAction(
    '[App] Set Inactivity Time',
    props<{ time: number }>()
)

export const setErrorTrialOver = createAction(
    '[App] Set Error Trial Over'
)

export const clearErrorTrialOver = createAction(
    '[App] Clear Error Trial Over'
)

export const openSideBar = createAction(
    '[Location Page] Open Side Bar',
)

/**
 * Action that is launched to indicate that a task is currently being executed.
 */
export const executeTask = createAction(
    '[App] Execute Task'
)

/**
 * Action launched to inform that a task has already finished its execution.
 */
export const executeTaskSuccess = createAction(
    '[App] Execute Task Success'
)

/**
 * Action that is launched to set an error on the app state.
 * Receives a string
 */
export const appError = createAction(
    '[App] App Error',
    props<{ error: string, url?: string }>()
)

/**
 * Action that is launched to clean the state that contains the errors.
 */
export const clearError = createAction(
    '[App] Clear Error'
)

/**
 * Action that is launched to clear the app state.
 */
export const clearState = createAction(
    '[App] Clear State'
)

/**
 * Action that is launched to set on the app state the last app notification
 * Receives a {@link NotificationModel}
 */
export const setLastNotification = createAction(
    '[App] Set New Notification',
    props<{ notification: NotificationModel }>()
)

/**
 * Action that is launched to set if intercom widget should be shown to customers or not.
 * Receives a boolean
 */
export const isShowIntercom = createAction(
    '[App] Is Show Intercom',
    props<{ show: boolean }>()
)

/**
 * Action launched to reset the errorTimeInactive based on recent activity
 */
export const setLastTimeActive = createAction(
    '[App] Set Last Time Active'
)

/**
 * Action that sets whether the inactivity time has been met or not
 * Receives a boolean.
 */
export const setErrorTimeInactive = createAction(
    '[App] Set Error Time Inactive',
    props<{ errorTimeInactive: boolean }>()
)

/**
 * Action that is dispatched to log all API request to the databa base.
 * Receives a {@link RequestModel}
 */
export const loggerRequest = createAction(
    '[App] Logger Request',
    props<{ request: RequestModel }>()
)

/**
 * Action that is launched when the logger request is success
 * Receives any type
 */
export const loggerRequestSuccess = createAction(
    '[App] Logger Request Success',
    props<{ response: any }>()
)

export const saveCognitoError = createAction(
    '[App] Save Cognito Error',
    props<{ request: RequestModel }>()
)

export const saveCognitoErrorSuccess = createAction(
    '[App] Save Cognito Error Success',
    props<{ response: any }>()
)

export const setRedirectedFromGoogle = createAction(
    '[App] Set Redirected From Google',
    props<{ redirected: boolean }>()
)

export const submitDataDeletionRequest = createAction(
    '[App] Submit Data Deletion Request',
    props<{ request: RequestModel }>()
)

export const submitDataDeletionRequestSuccess = createAction(
    '[App] Submit Data Deletion Request Success',
    props<{ data: string }>()
)
